/** A4 视觉画布中的内容区域高度，页眉、页脚与页边距不参与排版。 */
export const PDF_CONTENT_HEIGHT = 956;
export const PDF_BLOCK_GAP = 14;
export const PDF_CONTAINER_CLASS = 'ym-decision-pdf';
export const PDF_PAGE_CLASS = 'business-item-pdf';

interface MeasuredBlock {
  id: string;
  section: string;
  keepWithNext?: boolean;
  gapBefore?: number;
  timelineGroup?: string;
}

/** 测高分页与可见排版共用间距，页首不额外留白。 */
export function getBlockGap(block: MeasuredBlock, previous?: MeasuredBlock): number {
  if (!previous || (block.timelineGroup && block.timelineGroup === previous.timelineGroup)) return 0;
  return block.gapBefore ?? PDF_BLOCK_GAP;
}

/** 按实测高度排版，章节另起页，小标题尽量与下一块同页。 */
export function paginateBlocks<T extends MeasuredBlock>(
  blocks: T[],
  heights: number[],
  availableHeight = PDF_CONTENT_HEIGHT,
): T[][] {
  const pages: T[][] = [];
  let current: T[] = [];
  let usedHeight = 0;
  blocks.forEach((block, index) => {
    const height = Math.ceil(heights[index] || 0);
    const previous = current[current.length - 1];
    const gap = getBlockGap(block, previous);
    const next = blocks[index + 1];
    const nextHeight = block.keepWithNext && next?.section === block.section
      ? getBlockGap(next, block) + Math.ceil(heights[index + 1] || 0)
      : 0;
    const differentSection = previous && previous.section !== block.section;
    const overflow = usedHeight + gap + height > availableHeight;
    const orphanHeading = nextHeight > 0 && height + nextHeight <= availableHeight &&
      usedHeight + gap + height + nextHeight > availableHeight;
    if (current.length && (differentSection || overflow || orphanHeading)) {
      pages.push(current);
      current = [];
      usedHeight = 0;
    }
    usedHeight += (current.length ? gap : 0) + height;
    current.push(block);
  });
  if (current.length) pages.push(current);
  return pages;
}
